import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-ui-og-article',
  templateUrl: './ui-og-article.component.html',
  styleUrls: ['./ui-og-article.component.scss'],
})
export class UiOgArticleComponent implements OnInit {
  @Input() ogUrl?: string;
  @Input() ogType?: string;
  @Input() ogImage?: string;
  @Input() ogTitle?: string;
  @Input() ogDescription?: string;

  get domain() {
    return this.ogUrl && new URL(this.ogUrl)?.hostname;
  }

  constructor() {}

  ngOnInit() {}

  onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    window.open(this.ogUrl, '_blank');
  }
}
